import React from 'react';

const Partner = ({ title, name, bio }) => {
  return (
    <section className="section-container section-alt">
      <div className="content-wrapper">
        <div className="partner-container">
          <h3 className="partner-title">{title}</h3>
          <h2 className="partner-name">{name}</h2>
          <p className="partner-bio">{bio}</p>
        </div>
      </div>
    </section>
  );
};

export default Partner;
